<form [formGroup]="viewUpdateFrm" *ngIf="viewUpdateFrm" (ngSubmit)="saveIdmsViewData()">
    <div class="modal-header">
        <h4>Edit View</h4>
        <a class="close-icon" href="javascript:void()" ngbAutofocus (click)="closeModal()">
            <i class="flaticon2-cross"></i>
        </a>
    </div>
    <div class="modal-body output-lable">
        <div class="row align-items-center justify-content-between">
            <div class="col-md-12 mb-5">
                <mat-form-field class="example-full-width custom-text-field">
                    <input type="text" placeholder="Name" matInput name="Name" formControlName="Name" />
                </mat-form-field>
            </div>

            <div class="col-md-12" *ngIf="!View.isDocument">
                <mat-checkbox class="checkbox-wrap" (change)="IsDefaultChecked($event)" formControlName="IsDefault"> Is Default </mat-checkbox>
            </div>
            <div class="col-md-12">
                <mat-checkbox class="checkbox-wrap" (change)="IsDocumentChecked($event)" formControlName="IsDocument"> Is Document </mat-checkbox>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn secondary-ebtn" (click)="closeModal()">Cancel</button>
        <button type="submit" class="btn primary-ebtn" [disabled]="!(viewUpdateFrm.valid && viewUpdateFrm.dirty)">Save</button>
       
    </div>
</form>
